import {STATES} from 'common/domain/states';

const views = {
  myVacationsMobile: 'myVacationsMobile',
  periodListMobile: 'periodListMobile'
};

const from = {
  'team-requests': STATES.VACATIONS_ABSENCES.TEAM_REQUESTS,
  'team-calendar-mobile': STATES.VACATIONS_ABSENCES.TEAM_CALENDAR_MOBILE
};

class ManagerAsEmployeeCalendarMobileController {
  constructor($stateParams,
              $state,
              vacationEmployeeRepositoryService,
              vacationUserDataService,
              loadingMobileService,
              $window) {
    'ngInject';
    this.stateParams = $stateParams;
    this.userInceptionId = $stateParams.employeeId;
    this.state = $state;
    this.views = views;
    this.view = views.myVacationsMobile;
    this.UserDataService = vacationUserDataService;
    this.employeeRepositoryService = vacationEmployeeRepositoryService;
    this.loadingMobileService = loadingMobileService;
    this.isMobileApp = $window.innerWidth < 1024;
    this.dateToday = new Date();
    this.year = this.dateToday.getFullYear();
  }

  $onInit() {
    this.userId = this.UserDataService.getEmployee().userId;
    this._requestData(this.userId,this.userInceptionId);
  }

  _requestData(userId,userInceptionId) {
    this.loadingMobileService.show();
    return this.employeeRepositoryService.getEmployee(userId, this.year, userInceptionId)
      .then((employee) => {
        this._loadData(employee);
      })
      .finally(() => this.loadingMobileService.hide());
  }

  _loadData(employee) {
    this.currentEmployee = employee;
    this.rawPeriodDays = employee.periodInDays;
    this.user = employee.getProfile();
    this.availableVacations = employee.availableVacations;
    this.vacationCount = employee.getAgreementVacationCount();
    this.allPeriods = employee.allPeriods;
  }

  onExitInception() {
    this.state.go(from[this.stateParams.from]);
  }

  onChangeView($event) {
    this.loadingMobileService.show();
    this.view = $event.view;
  }

  isMyVacationsMobile() {
    return this.view === this.views.myVacationsMobile;
  }

  isPeriodListMobile() {
    return this.view === this.views.periodListMobile;
  }

  onClickPeriodMobileListLink() {
    this.view = this.views.periodListMobile;
  }
}

export default ManagerAsEmployeeCalendarMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendarMobile/managerAsEmployeeCalendarMobile.controller.js